import {
  useQuery,
  type UseQueryOptions,
  type UseQueryResult
} from "@tanstack/react-query";

import type { GetTransactionHistoryListRequestDto } from "../../dtos/get-transaction-history-list-request-dto";
import type { GetTransactionHistoryListResponseDto } from "../../dtos/get-transaction-history-list-response-dto";
import { OrderQueryKeys } from "../../generators/order-query-keys";
import { OrderService } from "../../services/order-service";

type UseGetTransactionHistoryListQueryProps = {
  queryParams: GetTransactionHistoryListRequestDto;
  options?: UseQueryOptions<GetTransactionHistoryListResponseDto>;
};

export const useGetTransactionHistoryListQuery = ({
  queryParams,
  options
}: UseGetTransactionHistoryListQueryProps): UseQueryResult<GetTransactionHistoryListResponseDto> => {
  return useQuery({
    queryKey: OrderQueryKeys.getTransactionHistoryList({ ...queryParams })
      .queryKey,
    queryFn: async () => {
      return await OrderService.getTransactionHistoryList({
        payload: queryParams
      });
    },
    ...options
  });
};
